import React, { FC } from 'react'

import logo from '../../assets/icons/mainLogo.svg'
import logoWhite from '../../assets/icons/mainLogoWhite.svg'
import { useThemeMode } from '../../theme/ThemeModeContext'

export const LogoImg: FC = () => {
  const { resolvedMode } = useThemeMode()

  return <img src={resolvedMode === 'light' ? logo : logoWhite} alt={'logo'} />
}
